import type { JSX } from 'react';
import { ContactSection } from '@/components/public/ContactSection';
import { ContactLeadForm } from '@/components/public/ContactLeadForm';
import { PublicPageSection } from '@/layouts/PublicPageLayout';
import type { ContactInfo } from '@/lib/constants/contactInfo';
import type { ContactPageFormContent, ContactSectionLabels } from '@/lib/types/siteSettings';

export function ContactSectionBlock({
  contactContent,
  contactInfo,
  contactPageFormContent,
  sharedContactLabels,
}: {
  contactContent: { heading: string; description: string };
  contactInfo: ContactInfo;
  contactPageFormContent: ContactPageFormContent;
  sharedContactLabels?: ContactSectionLabels;
}): JSX.Element {
  return (
    <PublicPageSection tone="muted" aria-label="Contact Strashin Developments" id="contact">
      <div className="flex flex-col gap-8">
        <ContactSection
          heading={contactContent.heading}
          description={contactContent.description}
          addressLines={contactInfo.addressLines}
          phone={contactInfo.phone}
          email={contactInfo.email}
          hours={contactInfo.hours}
          contacts={contactInfo.contacts}
          mapEmbedUrl={contactInfo.mapEmbedUrl}
          mapTitle={sharedContactLabels?.mapTitle}
          labels={sharedContactLabels}
        />
        <ContactLeadForm content={contactPageFormContent} contactPhone={contactInfo.phone} />
      </div>
    </PublicPageSection>
  );
}
